import {createSelector} from '@reduxjs/toolkit';

import {measurementSystems} from '../constants/preferences.js';

// Measurement System and Units

export const getMeasurementSystem = state => state.settings.measurementSystem;

export const getDistanceUnitsMetric = state =>
  state.settings.distanceUnitsMetric;
export const getDistanceUnitsUSC = state => state.settings.distanceUnitsUSC;

export const getAreaUnitsMetric = state => state.settings.areaUnitsMetric;
export const getAreaUnitsUSC = state => state.settings.areaUnitsUSC;

export const getDistanceUnits = createSelector(
  [getMeasurementSystem, getDistanceUnitsMetric, getDistanceUnitsUSC],
  (measurementSystem, distanceUnitsMetric, distanceUnitsUSC) =>
    measurementSystem === measurementSystems.metric
      ? distanceUnitsMetric
      : distanceUnitsUSC
);

export const getAreaUnits = createSelector(
  [getMeasurementSystem, getAreaUnitsMetric, getAreaUnitsUSC],
  (measurementSystem, areaUnitsMetric, areaUnitsUSC) =>
    measurementSystem === measurementSystems.metric
      ? areaUnitsMetric
      : areaUnitsUSC
);
